import jwt_decode from "jwt-decode";

export const isAuthenticated = () => {
  let tokenValid = false;

  try {
    if (sessionStorage.getItem("token").replace(/[\""]+/g, "")) {
      if (
        jwt_decode(sessionStorage.getItem("token").replace(/[\""]+/g, ""))
          .exp
      ) {
        tokenValid = true;
      } else {
        tokenValid = false;
      }
    }
  } catch (error) {
    tokenValid = false;
  }
  return tokenValid;
};

export const isPasswordDefine = () => {
  let hasPassword = false;

  try {
    if (sessionStorage.getItem("token")) {
      hasPassword = true;
    } else {
      hasPassword = false;
    }
  } catch (error) {
    hasPassword = false;
  }
  return hasPassword;
};
